import React from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevealSection } from './components/RevealSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PackSection } from './components/PackSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-ink-900 font-sans" data-id="element-0" data-mp="2wjgp1comflds">
      <AlertBar data-id="element-1" data-mp="2whxaprmizken" />
      <Hero data-id="element-2" data-mp="28ufoscpxzgjl" />
      <main data-id="element-3" data-mp="28tw62tsgwo4i">
        <HookSection data-id="element-4" data-mp="28tme50nv46w6" />
        <PainSection data-id="element-5" data-mp="28suumo7jhzm9" />
        <RevealSection data-id="element-6" data-mp="28sb9yzqi8x4j" />
        <BenefitsSection data-id="element-7" data-mp="23vkwmk634fmt" />
        <PackSection data-id="element-8" data-mp="23w4clvc6cty7" />
        <PricingSection data-id="element-9" data-mp="23utbk3a460as" />
        <FaqSection data-id="element-10" data-mp="23t8eo70bu59r" />
        <GuaranteeSection data-id="element-11" data-mp="3ik7g4ghnibqn" />
      </main>
      <Footer data-id="element-12" data-mp="3ij63w8owfj7c" />
      <StickyCta data-id="element-13" data-mp="3ijpbowku4r7n" />
    </div>;
}